import { render, staticRenderFns } from "./sensorCard.vue?vue&type=template&id=0ca9395a&scoped=true"
import script from "./sensorCard.vue?vue&type=script&lang=js"
export * from "./sensorCard.vue?vue&type=script&lang=js"
import style0 from "./sensorCard.vue?vue&type=style&index=0&id=0ca9395a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca9395a",
  null
  
)

export default component.exports